'use client';

import React, { useEffect, useRef, useState } from 'react';
import { IconButton } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
import { useWishlistToggle, getWishlistItem } from '@skin-seoul/service';
import { debounce } from 'es-toolkit';
interface FavoriteButtonProps {
  sku: string;
  size?: 'mobile' | 'desktop';
}
const FavoriteButton = ({
  sku,
  size = 'desktop'
}: FavoriteButtonProps) => {
  const {
    wishlistData,
    toggleWishlist
  } = useWishlistToggle();
  const {
    isWished: isServerWished
  } = getWishlistItem(wishlistData?.skus ?? [], sku);
  const [isWished, setIsWished] = useState(isServerWished);
  const toggleWishlistRef = useRef(toggleWishlist);
  const skuRef = useRef(sku);
  useEffect(() => {
    toggleWishlistRef.current = toggleWishlist;
    skuRef.current = sku;
  }, [toggleWishlist, sku]);
  const debouncedToggleRef = useRef(debounce(() => {
    toggleWishlistRef.current(sku);
  }, 1000));
  useEffect(() => {
    setIsWished(isServerWished);
  }, [isServerWished]);
  useEffect(() => {
    const debouncedFn = debouncedToggleRef.current;
    return () => {
      debouncedFn.cancel();
    };
  }, []);
  const handleWishlistToggle = () => {
    setIsWished(prev => !prev);
    debouncedToggleRef.current();
  };
  const isMobile = size === 'mobile';
  return <IconButton aria-label={isWished ? 'Remove from favorites' : 'Add to favorites'} onClick={handleWishlistToggle} border="1px solid" borderColor={isWished ? 'primary.400' : 'primary.600'} backgroundColor={isWished ? 'primary.50' : 'white'} color={isWished ? 'primary.400' : 'primary.600'} borderRadius="8px" width={isMobile ? '40px' : {
    base: '40px',
    tablet: '44px'
  }} height={isMobile ? '40px' : {
    base: '40px',
    tablet: '44px'
  }} padding="10px" _hover={{
    backgroundColor: isWished ? 'primary.100' : 'primary.50'
  }} data-sentry-element="IconButton" data-sentry-component="FavoriteButton" data-sentry-source-file="FavoriteButton.tsx">
      <LucideIcon name="Heart" size="md" color={isWished ? 'primary.400' : 'primary.600'} fill={isWished ? 'primary.400' : 'none'} data-sentry-element="LucideIcon" data-sentry-source-file="FavoriteButton.tsx" />
    </IconButton>;
};
export default FavoriteButton;